import { GridCellKind, type CustomCell, type CustomRenderer } from '@glideapps/glide-data-grid'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { RowData } from '@makyoapp/makyo-common'
import { ThemeMode } from '@makyoapp/makyo-ui'

import { generateQRCodeURL, QRCodeCell } from '@/core/models/columns/qrcode'

import { drawImage } from '../helpers/draw-image'

export interface CustomQRCodeCellProps {
  readonly type: ColumnTypes
  readonly cell: QRCodeCell
  readonly qrCodeOpts: Record<string, unknown>
  readonly extra: { theme: ThemeMode; rowData: RowData }
}

export type CustomQRCodeCell = CustomCell<CustomQRCodeCellProps>

const CustomQRCodeRenderer: CustomRenderer<CustomQRCodeCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell: CustomCell): cell is CustomQRCodeCell =>
    (cell.data as CustomQRCodeCellProps).type === ColumnTypes.QRCode,
  needsHover: false,
  needsHoverPosition: false,
  measure: (_ctx, cell) => cell.data.cell.toString().length * 50,
  draw: (args, cell) => {
    let qrCodeCell = cell.data.cell
    let qrCodeValue = qrCodeCell.value

    if (qrCodeValue) {
      const dataURL = generateQRCodeURL(qrCodeValue as string)
      drawImage(args, dataURL, 0, args.cell.contentAlign)
    }
  },
  onClick: (args) => {
    const cell = args.cell as CustomQRCodeCell
    const dataURL = cell.data.cell.toString()

    if (dataURL) {
      // see `GridPreviewModal.tsx` for more details
      const qrCodeClickEvent = new CustomEvent('preview-modal-open', {
        detail: { title: 'QR Code Preview', value: dataURL, width: 350 },
      })
      document.dispatchEvent(qrCodeClickEvent)
    }

    return undefined
  },
}

export default CustomQRCodeRenderer
